// @react
import React, { ReactElement } from 'react'
// @types
import {
  GetNetworkSummaryQuery,
  GetNetworkSummaryQueryVariables,
} from 'lib/graphql/graphqlTypes'
// @graphQL
import { GET_NETWORK_USERS_SUMMARY } from 'graphql/queries/userNetwork.query'
// @components
import NetworkCards from 'modules/onBoarding/components/Network/CardList'
import { useQuery } from '@apollo/client'
// @commons

const NetworkContainer = (): ReactElement => {
  const {
    loading: isLoading,
    error: isError,
    data: networkSummaryData,
  } = useQuery<GetNetworkSummaryQuery, GetNetworkSummaryQueryVariables>(
    GET_NETWORK_USERS_SUMMARY,
    {
      fetchPolicy: 'cache-first',
    },
  )

  return (
    <NetworkCards
      isLoading={isLoading}
      isError={isError}
      data={networkSummaryData}
    />
  )
}

export default NetworkContainer
